// extracted by mini-css-extract-plugin
module.exports = {"all":"e_kq","accent":"e_lq"};